import createIcon from '../../createIcon';

/**
 * @component @name LocalLibrary
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTEuMjc0NkM5LjY0IDkuMDc0NjEgNi40OCA3LjcyNDYxIDMgNy43MjQ2MVYxOC43MjQ2QzYuNDggMTguNzI0NiA5LjY0IDIwLjA3NDYgMTIgMjIuMjc0NkMxNC4zNiAyMC4wODQ2IDE3LjUyIDE4LjcyNDYgMjEgMTguNzI0NlY3LjcyNDYxQzE3LjUyIDcuNzI0NjEgMTQuMzYgOS4wNzQ2MSAxMiAxMS4yNzQ2Wk0xMiA3LjcyNDYxQzEzLjY2IDcuNzI0NjEgMTUgNi4zODQ2MSAxNSA0LjcyNDYxQzE1IDMuMDY0NjEgMTMuNjYgMS43MjQ2MSAxMiAxLjcyNDYxQzEwLjM0IDEuNzI0NjEgOSAzLjA2NDYxIDkgNC43MjQ2MUM5IDYuMzg0NjEgMTAuMzQgNy43MjQ2MSAxMiA3LjcyNDYxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalLibrary = createIcon('LocalLibrary', [
  [
    'path',
    {
      d: 'M12 11.2746C9.64 9.07461 6.48 7.72461 3 7.72461V18.7246C6.48 18.7246 9.64 20.0746 12 22.2746C14.36 20.0846 17.52 18.7246 21 18.7246V7.72461C17.52 7.72461 14.36 9.07461 12 11.2746ZM12 7.72461C13.66 7.72461 15 6.38461 15 4.72461C15 3.06461 13.66 1.72461 12 1.72461C10.34 1.72461 9 3.06461 9 4.72461C9 6.38461 10.34 7.72461 12 7.72461Z',
      key: 'orp7ty',
    },
  ],
]);

export default LocalLibrary;
